import AvailableCrm from "../../../shared/crm/AvailableCrm/AvailableCrm";

function AvailableCRMOperator(props) {
  return <AvailableCrm />;
}

export default AvailableCRMOperator;
